import { IErrorMessage } from '@hooks/use-error-message.ts';

export const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

export const CURACAO_CITIES = [
  'Willemstad',
  'Barber',
  'Soto',
  'Sint Michiel',
  'Santa Cruz',
  'Nieuwpoort',
  'Westpunt',
  'Lagún',
  'Tera Kòrá'
];

export const brandingErrorMessages: IErrorMessage = {
  name: {
    required: 'validation_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  }
};

export const organizationInfoErrorMessages: IErrorMessage = {
  name: {
    required: 'validation_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  email: {
    required: 'validation_email_required',
    pattern: 'validation_email_pattern'
  },
  phone: {
    required: 'validation_phone_number_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  country: {
    required: 'validation_country_required'
  },
  city: {
    required: 'validation_city_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  currency: {
    required: 'validation_currency_required'
  }
};
